import {put,takeLatest,call} from 'redux-saga/effects';
import * as productTypeService from "../../../../services/productTypeService";
import {
    GET_PRODUCT_TYPES,
    GET_PRODUCT_TYPES_SUCCESS,
    GET_PRODUCT_TYPES_ERROR
}
    from "../../../actions/menu/productTypes";

function* getProductTypesSaga(action) {
    try {
        const data=yield call(productTypeService.GetProductTypes,action.payload)
        yield put({
            type: GET_PRODUCT_TYPES_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_PRODUCT_TYPES_ERROR,error: error.data
        });
    }
}


export function* getProductTypesSagaWatcher() {
    yield takeLatest(GET_PRODUCT_TYPES,getProductTypesSaga);
}